import moment from 'moment-timezone'

export function isCurrentCycle(cycle) {
  const current = moment()
  return (
    current.isSameOrAfter(cycle.startsAt, 'day') &&
    current.isSameOrBefore(cycle.endsAt, 'day')
  )
}

export function formatCycleRange(cycle, format = 'MMM D, YYYY') {
  if (!cycle) return ''
  const startsAt = cycle.startsAtLong || cycle.startsAt
  const endsAt = cycle.endsAtLong || cycle.endsAt

  const start = startsAt ? moment(startsAt).format(format) : ''
  const end = endsAt ? moment(endsAt).format(format) : ''
  if (!start) return end
  if (!end) return start
  return `${start} to ${end}`
}
